export type MappedBasketItem<T> = T & {isSelected: boolean};
